import { Stack, Typography } from "@mui/material";
import BloodPressureCard from ".";
import { WellnessScoreStatus } from "../../../Common/types";

export default function BloodPressureCardExamples() {
  return (
    <Stack gap={3} width="100%">
      <Typography variant="h6" fontWeight={600}>
        Healthy
      </Typography>
      <BloodPressureCard
        metricValue="127 / 76"
        status={WellnessScoreStatus.Healthy}
        lastUpdated="2025-02-23T00:00:00Z"
      />

      <Typography variant="h6" fontWeight={600}>
        Needs Attention
      </Typography>
      <BloodPressureCard
        metricValue="127 / 76"
        status={WellnessScoreStatus.NeedsAttention}
        lastUpdated="2025-02-23T00:00:00Z"
      />

      <Typography variant="h6" fontWeight={600}>
        Needs Support
      </Typography>
      <BloodPressureCard
        metricValue="127 / 76"
        status={WellnessScoreStatus.NeedsSupport}
        lastUpdated="2025-02-23T00:00:00Z"
      />
    </Stack>
  );
}
